import React from 'react';

export default () => (
  <svg viewBox="0 0 25 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>ic-tick-confirmation</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="Prompt-FINAL-DESIGN"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="FINAL-Confirmation-Mobile"
        transform="translate(-22.000000, -1329.000000)"
      >
        <g id="Circle" transform="translate(10.000000, 1318.000000)">
          <g
            id="ic-tick-confirmation"
            transform="translate(13.000000, 12.000000)"
          >
            <g id="ic-tick">
              <polygon
                id="Fill-1"
                fill="#CCE8EC"
                points="7.66526527 19 0 11.3542253 3.71649225 7.64857011 7.66526527 11.5876414 19.2842084 0 23 3.70635402"
              />
              <polygon
                id="Stroke-2"
                stroke="#2765CF"
                strokeWidth="1.3"
                fill="#D9E6FB"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="7.66526527 19 0 11.3542253 3.71649225 7.64857011 7.66526527 11.5876414 19.2842084 0 23 3.70635402"
              />
            </g>
            <ellipse
              id="shadow"
              fill="#EEEEEE"
              cx="10"
              cy="25.6"
              rx="7"
              ry="1.3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
